$(document).ready(function() {
    $('.pr-item-js').on('click', function(e) { 
      e.preventDefault();
      
      $('.pr-item-js').removeClass('active');
      $(this).addClass('active');
      
      const prefixedId = 'files_date_' + $(this).attr('href').replace(/#/g, '');
      searchAndRenderFromJsonLd(prefixedId);
    });
    
    $('.t4s-tab-wrapper').each(function() {
      if ($(this).find('.tw-grid').children().length === 0) $(this).hide();
    });

    $($(".t4s-tab-wrapper .pr-item")[0]).click()
});
  
function searchAndRenderFromJsonLd(targetId) {
    const jsonObj = JSON.parse($('#'+targetId).text());
    console.log('jsonObj',jsonObj);
    
    const myfiles = jsonObj.itemListElement[0].item;

    renderfiles(".files-list", myfiles);
  }
  
  function renderfiles(selector, files) {
    const $container = $(selector);
    const $wrapper = $container.closest('.files-wrapper');
    const filesData = files.relatedLink;
    
    $(".no-results").fadeOut()
    $container.empty();
    $wrapper.find("h3").text(files.name);
    
    if (filesData?.length) {
      $.each(filesData, function() {
        $container.append(`
            <a target="_blank" class="tw-p-4 hover:tw-underline" href="${this.url}" rel="noopener" aria-describedby="a11y-new-window-message">
                <div class="tw-flex tw-gap-4 tw-items-center tw-leading-tight ">
                    <div class="tw-w-4 tw-h-4 tw-rounded-full tw-inline-block tw-bg-vi"></div>    
                    ${this.name}
                </div>
            </a>
        `);
      });
    } else{
        $(".no-results").fadeIn()
    }
  }
  